export function isProduction (): boolean {
  if (import.meta.env.VITE_VUE_APP_PRODUCTION && import.meta.env.VITE_VUE_APP_PRODUCTION == "true") {
    return true;
  } else {
    return false;
  }
}